<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card v-if="!isFetching">
        <v-card-title>{{translater.__('Edit LatLng')}}</v-card-title>
        <v-card-text>
          <v-container wrap>
            <v-flex xs12>
              <v-text-field :label="translater.__('Lat')" v-model="lat"></v-text-field>
              <v-text-field :label="translater.__('Lng')" v-model="lng"></v-text-field>
              <small class="error" v-if="typeof error !== 'undefined'">{{error}}</small>
            </v-flex>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close()">{{translater.__('Close')}}</v-btn>
          <v-btn
            :disabled="!valid"
            color="blue darken-1"
            flat
            @click.native="save"
          >{{translater.__('Save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  name: "EditCheckpointLatLng",
  props: ["dialog", "element"],
  data() {
    return {
      isFetching: false,
      error: undefined,
      valid: true,
      lat: 0,
      lng: 0
    };
  },

  computed: {
    translater: {
      get() {
        return this.$store.getters["translate/translater"];
      }
    }
  },

  created() {
    //console.log(this.element);
    this.$store
      .dispatch("checkpoints/getItem", this.element)
      .then(checkpointRes => {
        const checkpoint = checkpointRes.data;
        this.lat = checkpoint.geometry.coordinates[1];
        this.lng = checkpoint.geometry.coordinates[0];
      })
      .catch(err => {
        console.log("#err,", err);
      });

    /*this.$store.dispatch('checkpoints/getItem', this.element).then((checkpoint) => {
            console.log(checkpoint)
        }).catch((err) => {
            console.log(err)
        })*/
  },

  mounted() {
    this.$nextTick(() => {
      document.getElementsByClassName(
        "v-dialog__content"
      )[0].style.zIndex = 3000;
    });
  },

  methods: {
    close() {
      this.$emit("toggleEditCheckpointLatLng", false);
    },

    save() {
      this.valid = false;
      let lat = Number(this.lat);
      let lng = Number(this.lng);

      this.$store
        .dispatch(`checkpoints/updateLatLng`, {
          lat,
          lng,
          id: this.element._id
        })
        .then(res => {
          this.valid = true;
          this.close();
          let startMoved = false;
          if (this.element.properties.isStart === true) {
            //window.vm.$emit('updateRoutePositionAfterStartMoved', {start: this.element, lat: this.lat, lng: this.lng})
            startMoved = true;
          }

          window.vm.$emit("updateMarkerPositionAfterLatLngUpdated", {
            element: this.element,
            lat,
            lng,
            startMoved
          });
          //console.log(res.status)
        })
        .catch(err => {
          this.valid = true;
        });
    }
  }
};
</script>
